import React from "react";
import DocumentsLayout from "../../Components/Documents/DocumentsLayout.jsx";

/** Startseite des Bereichs Dokumente. */
export default function Index() {
    return (
        <DocumentsLayout>
            <h1 className="h4 mb-3">Dokumente</h1>
            <p className="text-muted">Wähle links eine Seite.</p>
        </DocumentsLayout>
    );
}
